import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearAuthRequestFailure,
  createOnErrorCallback,
  receiveAuthRequest,
  sendAuthRequest,
} from '../../redux/actions/auth';

/**
 * KU
 *
 * Returns an object with helper curry functions to share code
 * across hooks that use the `authRequest` helper method */
export default function useAuthRequestCallbacks() {
  const dispatch = useDispatch();

  const onResponse = useCallback(() => {
    dispatch(receiveAuthRequest());
  }, []);

  const onPreRequest = useCallback(() => {
    dispatch(clearAuthRequestFailure());
    dispatch(sendAuthRequest());
  }, []);

  const onError = useCallback(createOnErrorCallback(dispatch), []);

  return { onResponse, onError, onPreRequest };
}
